import React, {useContext, useState} from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import TopNavHomeComponent from '../components/include/TopNavHomeComponent';
import TopNavLoginComponent from '../components/include/TopNavLoginComponent';
import TopNavComponent from '../components/include/TopNavComponent';
import FooterComponent from '../components/include/FooterComponent';
import BottomNavComponent from '../components/include/BottomNavComponent';

import HomeComponent from '../components/home/HomeComponent';
import VendorsComponent from '../components/vendor/VendorsComponent';
import SignupComponent from '../components/pages/SignupComponent';
import SocialSignupComponent from '../components/pages/SocialSignupComponent';
import LoginComponent from '../components/pages/LoginComponent';
import LoginOtpComponent from '../components/pages/LoginOtpComponent';
import PasswordComponent from '../components/pages/PasswordComponent';
import ForgotPasswordComponent from '../components/pages/ForgotPasswordComponent';
import SearchComponent from '../components/oneday/SearchComponent';
import HelpComponent from '../components/pages/HelpComponent';
import SelectCategoryComponent from '../components/pages/SelectCategoryComponent';
import ViewAllAlldayDealsComponent from '../components/allday/viewall/viewAllDealsComponent';
import AlldayCategoryDealsComponent from '../components/allday/category-deals/categoryDealsComponent';
import AlldayDealDetailComponent from '../components/allday/deal/DealDetailComponent';
import ViewAllOnedayDealsComponent from '../components/oneday/viewall/viewAllDealsComponent';
import OnedayCategoryDealsComponent from '../components/oneday/category-deals/categoryDealsComponent';
import OneDayDealDetailComponent from '../components/oneday/deal/DealDetailComponent';

import PrivateRoute from '../components/PrivateRoute';
import ProfileInfoComponent from '../components/pages/ProfileInfo';
import EditProfileComponent from '../components/pages/EditProfile';
import SettingsComponent from '../components/pages/Settings';
import ChangePasswordComponent from '../components/pages/ChangePassword';
import FollowingComponent from '../components/pages/Following';
import PendingReviewsComponent from '../components/reviews/Pending';
import RatedReviewsComponent from '../components/reviews/Rated';
import RatedReviewDetailComponent from '../components/reviews/RatedReviewDetail';
import PendingReviewDetailComponent from '../components/reviews/PendingReviewDetail';
import FavoritesComponent from '../components/pages/Favorites';
import ReferComponent from '../components/pages/Refer';
import MyPurchasedOneDayDealsComponent from '../components/oneday/my-purchased/MyPurchased';
import EntryPassOneDayDealComponent from '../components/oneday/entry-pass/EntryPass';
import SharedOneDayDealsComponent from '../components/oneday/shared-deals/ViewAllDeals';
import SharedOneDayDealComponent from '../components/oneday/shared-deals/SharedDeal';
import SharedOnedayPaymentComponent from '../components/oneday/shared-deals/payment/Payment';
import OnedayPaymentComponent from '../components/oneday/payment/Payment';
import AlldayPaymentComponent from '../components/allday/payment/Payment';
import MyPurchasedAllDayDealsComponent from '../components/allday/my-purchased/MyPurchased';
import EntryPassAllDayDealComponent from '../components/allday/entry-pass/EntryPass';
import SharedAlldayDealsComponent from '../components/allday/shared-deals/ViewAllDeals';
import SharedAlldayDealComponent from '../components/allday/shared-deals/SharedDeal';
import SharedAlldayPaymentComponent from '../components/allday/shared-deals/payment/Payment';
import ReviewsComponent from '../components/vendor/Reviews';

import CartComponent from '../components/cart/cart';
import CartPaymentComponent from '../components/cart/payment/Payment';
import PurchasedCartComponent from '../components/cart/Purchased';
import PurchasedAlldayCartDetail from '../components/cart/PurchasedAlldayDetail';
import PurchasedOnedayCartDetail from '../components/cart/PurchasedOnedayDetail';

import AddtoShareComponent from './../components/AddtoShare';
import SharedDealComponent from './../components/SharedDeal';
import NotFoundPage from './../components/pages/NotFoundPage';

import NetworkDetector from './../components/NetworkDetector';

import { AuthContext } from "./../context/auth";
import TopNavForgotPassword from "../components/include/TopNavForgotPassword";

function App() {
    const [contextState] = useState(
        {
            authenticated: !!localStorage.getItem('silverbackAuthenticated'),
            token:localStorage.getItem('silverbackToken'),
            cartCount : localStorage.getItem('silverbackCartCount') == null ? 0 : localStorage.getItem('silverbackCartCount'),
            lastUsedPromo : localStorage.getItem('silverbackLastUsedPromo')
        });

  return (
      <AuthContext.Provider value={contextState}>
        <Router>
          <main>
              <Switch>
                  <Route exact path={`${process.env.PUBLIC_URL}/`} component={TopNavHomeComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/login`} component={TopNavLoginComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/password`} component={TopNavForgotPassword}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/forgot-password`} component={TopNavForgotPassword}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/login-otp`} component={TopNavForgotPassword}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/signup`} component={TopNavForgotPassword}/>
                  <Route component={TopNavComponent}/>
              </Switch>
              <Switch>
                  <Route exact path={`${process.env.PUBLIC_URL}/vendors/`} component={VendorsComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/signup/`} component={SignupComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/social-signup/`} component={SocialSignupComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/login/`} component={LoginComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/login-otp/`} component={LoginOtpComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/social-login-otp/`} component={LoginOtpComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/password/`} component={PasswordComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/forgot-password/`} component={ForgotPasswordComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/`} component={HomeComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/search/`} component={SearchComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/help/`} component={HelpComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/select-category/:id/`}  component={SelectCategoryComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/category/allday/view-all/:cat_id?/`} component={ViewAllAlldayDealsComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/allday/category-deals/`} component={AlldayCategoryDealsComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/allday/deal/:id/`} component={AlldayDealDetailComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/category/oneday/view-all/:cat_id?/`} component={ViewAllOnedayDealsComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/oneday/category-deals/`} component={OnedayCategoryDealsComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/oneday/deal/:id/`} component={OneDayDealDetailComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/profile/`} component={ProfileInfoComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/edit-profile/`} component={EditProfileComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/settings/`} component={SettingsComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/change-password/`} component={ChangePasswordComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/following/`} component={FollowingComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/favorites/`} component={FavoritesComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/reviews/pending/`} component={PendingReviewsComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/reviews/rated/`} component={RatedReviewsComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/reviews/rated/:id/`} component={RatedReviewDetailComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/reviews/pending/:id/`} component={PendingReviewDetailComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/refer/`} component={ReferComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/oneday/my-purchased-deals/`} component={MyPurchasedOneDayDealsComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/oneday/entry-pass/:id/`} component={EntryPassOneDayDealComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/oneday/payment/:id/`} component={OnedayPaymentComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/oneday/shared-deals/`} component={SharedOneDayDealsComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/oneday/shared-deal/:id/`} component={SharedOneDayDealComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/oneday/shared-deal/payment/:id/`} component={SharedOnedayPaymentComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/allday/payment/:id/`} component={AlldayPaymentComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/allday/my-purchased-deals/`} component={MyPurchasedAllDayDealsComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/allday/entry-pass/:id/`} component={EntryPassAllDayDealComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/allday/shared-deals/`} component={SharedAlldayDealsComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/allday/shared-deal/:id/`} component={SharedAlldayDealComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/allday/shared-deal/payment/:id/`} component={SharedAlldayPaymentComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/cart/`} component={CartComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/cart/payment/`} component={CartPaymentComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/cart/purchased/`} component={PurchasedCartComponent}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/cart/purchased/allday/:id/`} component={PurchasedAlldayCartDetail}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/cart/purchased/oneday/:id/`} component={PurchasedOnedayCartDetail}/>
                  <PrivateRoute exact path={`${process.env.PUBLIC_URL}/vendor/reviews/:id/`} component={ReviewsComponent}/>

                  <Route exact path={`${process.env.PUBLIC_URL}/deal/:deal_id/:host_id/`} component={AddtoShareComponent}/>
                  <Route exact path={`${process.env.PUBLIC_URL}/deal/:deal_id/`} component={SharedDealComponent}/>
                  <Route path={`${process.env.PUBLIC_URL}/404`} component={NotFoundPage} />
                  <Route component={NotFoundPage} />
              </Switch>
            <FooterComponent/>
          </main>
            <Switch>
                <Route exact path={`${process.env.PUBLIC_URL}/login/`}/>
                <Route exact path={`${process.env.PUBLIC_URL}/login-otp`}/>
                <Route exact path={`${process.env.PUBLIC_URL}/forgot-password/`}/>
                <Route exact path={`${process.env.PUBLIC_URL}/password/`}/>
                <Route component={BottomNavComponent}/>
            </Switch>
        </Router>
        </AuthContext.Provider>
  );
}

export default NetworkDetector(App);
